// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventProvisioning
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.eventlogger.EventProvisioningIssuerData
import org.multipaz.cbor.toDataItem
import org.multipaz.provisioning.Display
import org.multipaz.cbor.buildCborArray
import org.multipaz.eventlogger.EventProvisioningCredentialData
import org.multipaz.eventlogger.toDataItem
import org.multipaz.provisioning.toDataItem
import org.multipaz.eventlogger.fromDataItem
import org.multipaz.provisioning.fromDataItem

fun EventProvisioning.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "kHjObHRcGXlTp6M4BWVtUoB_CjIFBWn66H5BQx4vXS0")
val EventProvisioning_cborSchemaId = ByteString(-112, 120, -50, 108, 116, 92, 25, 121, 83, -89, -93, 56, 5, 101, 109, 82, -128, 127, 10, 50, 5, 5, 105, -6, -24, 126, 65, 67, 30, 47, 93, 45)

fun EventProvisioning.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Provisioning")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("issuerData", this.issuerData.toDataItem())
    builder.put("initialProvisioning", this.initialProvisioning.toDataItem())
    builder.put("documentId", Tstr(this.documentId))
    val documentName = this.documentName
    if (documentName != null) {
        builder.put("documentName", Tstr(documentName))
    }
    val display = this.display
    if (display != null) {
        builder.put("display", display.toDataItem())
    }
    val map0 = this.credentialsFetched.let {
        buildCborMap {
            for (entry in it.entries) {
                val array = entry.value.let {
                    buildCborArray {
                        for (value in it) {
                            add(value.toDataItem())
                        }
                    }
                }
                put(Tstr(entry.key), array)
            }
        }
    }
    builder.put("credentialsFetched", map0)
    return builder.end().build()
}

fun EventProvisioning_fromDataItem(dataItem: DataItem): EventProvisioning {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map1 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map1
    val issuerData = EventProvisioningIssuerData.fromDataItem(dataItem["issuerData"])
    val initialProvisioning = dataItem["initialProvisioning"].asBoolean
    val documentId = dataItem["documentId"].asTstr
    val documentName0 = if (dataItem.hasKey("documentName")) {
        dataItem["documentName"].asTstr
    } else {
        null
    }
    val display0 = if (dataItem.hasKey("display")) {
        Display.fromDataItem(dataItem["display"])
    } else {
        null
    }
    val map2 = dataItem["credentialsFetched"].let {
        buildMap<String, List<EventProvisioningCredentialData>> {
            for (entry0 in it.asMap.entries) {
                val array0 = entry0.value.let {
                    buildList<EventProvisioningCredentialData> {
                        for (value in it.asArray) {
                            add(EventProvisioningCredentialData.fromDataItem(value))
                        }
                    }
                }
                put(entry0.key.asTstr, array0)
            }
        }
    }
    val credentialsFetched = map2
    return EventProvisioning(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        issuerData = issuerData,
        initialProvisioning = initialProvisioning,
        documentId = documentId,
        documentName = documentName0,
        display = display0,
        credentialsFetched = credentialsFetched,
    )
}
